<template>
  <div class="year-empty-wrapper">
    <div class="year-empty-container">
      <div class="empty-content">
        <div class="empty-inner">
          <!-- クマの画像 -->
          <div class="bear-image">
            <img
              src="/img/campaign/reality_histories_20m/img_empty_bear.png"
              alt="空の状態のクマ"
              class="bear-img"
            />
          </div>

          <!-- メッセージテキスト -->
          <div class="empty-message">
            <p class="message-text">{{ $t('historiesNoteText') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class YearEmptyState extends Vue {
  @Prop({ type: Number, required: true })
  year!: number
}
</script>

<style scoped>
.year-empty-wrapper {
  width: 100%;
  padding: 0 16px;
}

.year-empty-container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  background: linear-gradient(121.668deg, #DC7EFF 0%, #8CAAFD 100%);
  overflow: hidden;
}

.empty-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}

.empty-inner {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  padding: 60px 16px;
  position: relative;
  width: 100%;
}

/* クマの画像 */
.bear-image {
  position: relative;
  width: 210px;
  height: 100px;
  flex-shrink: 0;
}

.bear-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* メッセージテキスト */
.empty-message {
  position: relative;
  width: 311px;
  flex-shrink: 0;
}

.message-text {
  font-weight: 300;
  font-style: normal;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: normal;
  margin: 0;
  display: block;
}
</style>
